import {mapToMaterialsById, useMaterials} from '@domain/materials'
import {CardTitle} from '@hconnect/uikit/src/lib2'
import {useUpmPlantContext} from '@hconnect/upm'
import {Box, Dialog, DialogContent, Typography} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {
  useUrlParam,
  useMaterialOrdersCommentsByOrderId,
  useMaterialOrdersQuery,
  useScheduleAgreementsByVendorQuery
} from '../../hooks'
import {useSelectedMaterialOrder, useSelectedTimeframe} from '../../providers'

import {CreateEditMaterialOrderDialogContent} from './CreateEditMaterialOrderDialogContent'

export const CreateEditMaterialOrderDialog: React.FC = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const materialIdParam = useUrlParam('materialId')
  const materialId = Number(materialIdParam)
  const {plantId: plantCode} = useUpmPlantContext()
  const {data: materialsById} = useMaterials({
    plantCode,
    options: {
      select: mapToMaterialsById
    }
  })
  const {data: scheduleAgreements} = useScheduleAgreementsByVendorQuery({plantCode, materialId})
  const {selectedMaterialOrder} = useSelectedMaterialOrder()
  const {selectedTimeframe} = useSelectedTimeframe()

  const [start, end] = selectedTimeframe ?? []

  const {data: currentMaterialOrder} = useMaterialOrdersQuery({
    plantCode,
    materialId,
    from: start?.toISOString(),
    to: end?.toISOString(),
    options: {
      enabled: Boolean(selectedTimeframe),
      select: (orders) => orders.find((order) => order.id === selectedMaterialOrder?.id)
    }
  })

  const {data: materialOrdersCommentsByOrderId} = useMaterialOrdersCommentsByOrderId()

  if (!materialsById) {
    throw new Error('MaterialsById query should be loaded before rendering this component')
  }
  return (
    <Dialog
      open={Boolean(selectedMaterialOrder)}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') {
          return
        }
      }}
    >
      <DialogContent sx={{width: ({spacing}) => spacing(44)}}>
        {selectedMaterialOrder && scheduleAgreements && (
          <>
            <Box sx={{mb: 3}}>
              <CardTitle sx={{mb: 0}}>
                {t(
                  selectedMaterialOrder.id !== undefined
                    ? 'stock.materialOrders.editMaterialOrder'
                    : 'stock.materialOrders.newMaterialOrder'
                )}
              </CardTitle>
              <Typography variant="caption">{materialsById[materialId].name}</Typography>
            </Box>
            <CreateEditMaterialOrderDialogContent
              materialOrder={currentMaterialOrder}
              scheduleAgreements={scheduleAgreements}
              commentsByOrderId={materialOrdersCommentsByOrderId}
            />
          </>
        )}
      </DialogContent>
    </Dialog>
  )
}
